import {BaseConfig} from "../../infrastructure/config/base-config";
import {AthletePropositionBetModuleTerms} from "./athlete-proposition-bet-module.terms";
import {APP} from "../../core/app/consts";

export class AthletePropositionBetModuleConfig extends BaseConfig {
  static injectables = [AthletePropositionBetModuleTerms];

  constructor(terms: AthletePropositionBetModuleTerms) {
    super('propositionBetsDetails', null, terms);

    this.source = APP.ANALYTICS.SOURCES.athletePropositionBet;
  }
}
